import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useParams } from "react-router-dom";
import { getCategoriesPosts } from "../services/categories.services";
import { formatDateMDDYYYY } from "../utils/Date.util";
import { useInView } from "react-intersection-observer";

const CategoryPosts = () => {
    const [posts, setPosts] = useState(null);
    const { category } = useParams();
    const { state } = useLocation();
    const [postsPage, setPostsPage] = useState(1);
    const [lastPage, setLastPage] = useState(null);

    const fetchCategoryPosts = async () => {
        let postsResult;
        try {
            postsResult = await getCategoriesPosts(postsPage, state.name);
            console.log("POSTS RESULT ----> ", postsResult);
        } catch (error) {
            console.error("Error: ", error.response, error.message);
            //toast.error("Error fetching posts.");
        } finally {
            if(postsResult.data?.length > 0 ) {
              setPosts((prev) => [...prev, ...postsResult.data]);
            } else {
              setPosts([])
            }
            setLastPage(postsResult.last_page);
            setPostsPage((prev) => prev + 1);
        }
    };

    const [ref, inView] = useInView({
        threshold: 0.5, // Trigger when 50% of the element is visible
    });

    // const handleInView = () => {
    //   console.log('Div is in view!');
    //   console.log(postsPage, lastPage);
    //   // Call your function here
    //   fetchCategoryPosts();
    // };

    useEffect(() => {
        setPosts(null);
        fetchCategoryPosts();
    }, [state]);

    if (!posts) {
        return (
            <section className="space">
                <div className="container">
                    <div className="row gy-30">
                        <p>Loading...</p>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="space">
            <div className="container">
                <div className="row gy-30">
                    {posts.length > 0 ? (
                        posts.map((post) => {
                            return (
                                <div
                                    className="col-xl-3 col-lg-4 col-sm-6"
                                    key={post.id}
                                >
                                    <div className="blog-style1">
                                        <div className="blog-img">
                                            <img
                                                src={`${process.env.REACT_APP_REDLINES_IMAGE_STORAGE}/${post.featured_image}`}
                                                alt=""
                                            />
                                            <NavLink
                                                data-theme-color="#59C2D6"
                                                to={`/post/${post.id}`}
                                                state={{ postDetails: post }}
                                                className="category"
                                            >
                                                {category}
                                            </NavLink>
                                        </div>
                                        <h3 className="box-title-20">
                                            <NavLink
                                                state={{ postDetails: post }}
                                                className="hover-line"
                                                to={`/post/${post.id}`}
                                            >
                                                {post.title}
                                            </NavLink>
                                        </h3>
                                        <div className="blog-meta">
                                            {/* <a href="author.html">
                          <i className="far fa-user"></i>By - Tnews
                        </a> */}
                                            <NavLink
                                                state={{ postDetails: post }}
                                                to={`/post/${post.id}`}
                                            >
                                                <i className="fal fa-calendar-days"></i>
                                                {formatDateMDDYYYY(
                                                    post.created_at
                                                )}
                                            </NavLink>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <p>No Posts found for {category}</p>
                    )}
                </div>
            </div>
        </section>
    );
};

export default CategoryPosts;
